import axios from 'axios';
import qs from 'qs';
import store from '../store';
import { webchatAuth } from '@/services/weixin';

//1、全局配置，如果设置了跨域代理就不要需要设置axios.defaults.baseURL
axios.defaults.baseURL = ' https://class.ctdsb.net/btapl/';
axios.defaults.timeout = 10000;

//2、请求拦截器
axios.interceptors.request.use(config => {
    //请求发出前处理，带上token和userid
    config.headers.common['accessToken'] = store.getters.userInfo.accessToken;
    // config.headers.common['accessToken'] = "rJKhu7LA2RmmREdcMyxx0WLZ8n99w5hpRhOeyy6rt5UlB5shnmNyxWwd0hDnXblEqHXN8dcXFRPkds91heXIZ6g0keUjSalRL0OcS9mWrpLwQjADb6OBELQxeYrNgnhW";
    return config;
}, error => {
    //请求发出前发生错误
    return Promise.error(error);
});

//3、相应拦截器
axios.interceptors.response.use(response => {
    if (response && (response.status == 200)) {
        return Promise.resolve(response);
    } else {
        return Promise.reject(response);
    };
}, error => {
    return Promise.reject(error.response);
});

//封装get方法
function httpGet(url, params) {
    if (!!url) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params || {}
            }).then(res => {
                if (res && res.data) {
                    if (res.data.code === 200) {
                        resolve(res.data);
                    } else if (res.data.code == 401 || res.data.code == 403) {
                        //重新授权
                        // webchatAuth();
                    } else {
                        reject(res.data.msg || '请求错误');
                    };
                } else {
                    reject('请求失败');
                };
            }).catch(err => {
                reject('请求失败');
            });
        });
    };
    return new Promise.reject('请求初始化失败');
};
//封装get方法
function httpGetForm(url, params) {
    if (!!url) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params || {}
            }, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res && res.data) {
                    if (res.data.code === 200) {
                        resolve(res.data);
                    } else if (res.data.code == 401 || res.data.code == 403) {
                        //重新授权
                        webchatAuth();
                    } else {
                        reject(res.data.msg || '请求错误');
                    };
                } else {
                    reject('请求失败');
                };
            }).catch(err => {
                reject('请求失败');
            });
        });
    };
    return new Promise.reject('请求初始化失败');
};

//封装post请求方法
function httpPost(url, params) {
    if (!!url) {
        return new Promise((resolve, reject) => {
            const data = params;
            axios.post(url, data || {}).then(res => {
                if (res && res.data) {
                    if (res.data.code === 200) {
                        resolve(res.data);
                    } else if (res.data.code == 401 || res.data.code == 403) {
                        webchatAuth();
                    } else {
                        reject(res.data.msg);
                    };
                } else {
                    reject('请求失败');
                };
            }).catch(err => {
                reject('请求失败');
            });
        });
    };
    return new Promise.reject('请求初始化失败');
};


//封装post请求方法
function httpPostFile(url, params) {
    if (!!url) {
        return new Promise((resolve, reject) => {
            const data = params;
            axios.post(url, qs.stringify(params) || {}, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            ).then(res => {
                if (res && res.data) {
                    if (res.data.code === 200) {
                        resolve(res.data);
                    } else if (res.data.code == 401 || res.data.code == 403) {
                        webchatAuth();
                    } else {
                        reject(res.data.msg);
                    };
                } else {
                    reject('请求失败');
                };
            }).catch(err => {
                reject('请求失败');
            });
        });
    };
    return new Promise.reject('请求初始化失败');
};

//封装getlogin方法
function httpGetLogin(url, params) {
    if (!!url) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params || {}
            }).then(res => {
                if (res && res.data) {
                    if (res.data.code === 200) {
                        resolve(res.data);
                    } else if (res.data.code == 401 || res.data.code == 403) {
                        //重新授权
                        resolve(res.data);
                    } else {
                        reject(res.data.msg || '请求错误');
                    };
                } else {
                    reject('请求失败');
                };
            }).catch(err => {
                reject('请求失败');
            });
        });
    };
    return new Promise.reject('请求初始化失败');
};

export {
    httpGet,
    httpPost,
    httpPostFile,
    httpGetForm,
    httpGetLogin
};